import styled from 'styled-components';

import { designSystemTokens } from '../../tokens';

const { colors, shades } = designSystemTokens;

type FabProps = {
    desktopSize: number;
    mobileSize: number;
};

type BadgeProps = {
    isNotificationCount?: boolean;
};

export const FabContainer = styled.button<FabProps>`
    align-items: center;
    background: transparent;
    border: 2px solid ${shades.primary.light[20]};
    border-radius: ${(props) => (props.desktopSize ? `${props.desktopSize / 2}px` : '50%')};
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: ${(props) => (props.desktopSize ? `${props.desktopSize}px` : '100%')};
    justify-content: center;
    position: relative;
    width: auto;
    min-width: ${(props) => (props.desktopSize ? `${props.desktopSize}px` : '100%')};

    :hover {
        background: ${shades.primary.light[20]};
        border-color: transparent;
    }
`;

export const IconContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    width: 100%;

    svg {
        fill: ${colors.primary.light};
    }
`;

export const Badge = styled.div<BadgeProps>`
    align-items: center;
    background: ${(props) => (props.isNotificationCount ? colors.secondary.error : colors.primary.light)};
    border: 3px solid ${colors.primary.dark};
    border-radius: 14px;
    color: ${(props) => (props.isNotificationCount ? colors.primary.light : colors.primary.dark)};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 28px;
    justify-content: center;
    position: absolute;
    right: -6px;
    top: -6px;
    width: 28px;
`;

export const LabelContainer = styled.div`
    margin-left: 5px;
`;
